import { DnvUrlProvider } from 'dnv-lib';

export class AppUrlProvider implements DnvUrlProvider {
  constructor(private hostBaseUrlPrefix: string) { }
  DefaultMapView(): string { return 'api/MapView/DefaultMapView/geotools'; }
  DefaultMapViewSave(): string { return this.hostBaseUrlPrefix + 'api/MapView/DefaultMapViewSave'; }
  DefaultMapViewDelete(): string { return this.hostBaseUrlPrefix + 'api/MapView/DefaultMapViewDelete'; }
  MapViews(): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViews/geotools'; }
  MapViewOpenShared(sharedId: string): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewOpenShared/' + sharedId; }
  MapViewSave(): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewSave'; }
  MapViewSaveAs(): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewSaveAs'; }
  MapViewDelete(): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewDelete'; }
  MapViewRenameTo(): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewRenameTo'; }
  MapViewGetById(Id: number): string { return this.hostBaseUrlPrefix + 'api/MapView/MapViewGetById/' + Id; }
}
